import ArticleHeaderClassroomApi from './ArticleHeaderClassroomApi';
export default ArticleHeaderClassroomApi;
